// extracted by mini-css-extract-plugin
export default {"root":"Footer__root--CLrmz","content":"Footer__content--uSbyN","text":"Footer__text--EeTYr","logo":"Footer__logo--oaw4u","agents":"Footer__agents--KToE1"};